<p-confirmDialog key="add" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Menu-->
<div class="MainGrid2Col">
	<label>Student ID:</label>
	<label>{{ StudentID }}</label>

	<label>Student Name:</label>
	<label>{{ StudentName }}</label>

	<label>Type:</label>
	<div class="MeritRadio">
		<input id="Merit" value="0" name="IsDemerit" [(ngModel)]="IsDemerit" (ngModelChange)="onTypeChange($event)" style="margin: 2px 0px 0px" type="radio" />
		<label for="Merit" style="margin: 0px">Merit</label>

		<input
			id="Demerit"
			value="1"
			name="IsDemerit"
			[(ngModel)]="IsDemerit"
			(ngModelChange)="onTypeChange($event)"
			style="margin: 2px 0px 0px"
			type="radio"
		/>
		<label for="Demerit" style="margin: 0px">Demerit</label>
	</div>

	<label>Merit/Demerit:</label>
	<select class="form-control" [(ngModel)]="MeritID" (ngModelChange)="onMeritChange($event)">
		<option *ngFor="let r of lstMerit" [ngValue]="r.MeritID">
			{{ r.MeritDesc }}
		</option>
	</select>

	<label>Date/Time:</label>
	<div>
		<p-calendar showIcon="true" showButtonBar="true" [(ngModel)]="MeritDate"></p-calendar>
		<p-calendar showIcon="true" hourFormat="12" [timeOnly]="true" showButtonBar="true" [(ngModel)]="MeritTime"></p-calendar>
	</div>

	<label>Comments:</label>
	<textarea [(ngModel)]="Commment" rows="5" class="TextArea"></textarea>

	<label>Value:</label>
	<div class="Vals">
		<input class="form-control" type="number" [(ngModel)]="MeritVal" [min]="MinVal" [max]="MaxVal" />
		<label>Valid between {{ MinVal }} and {{ MaxVal }}</label>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onAdd()">Add</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
